import { useState } from "react";
import NoteContext from "./noteContext";


const host = process.env.REACT_APP_BASE_URL;
const NoteState = (props) => {
    const noteInitial = []

    const [note, setnotes] = useState(noteInitial);

    const getnotes = async () => {
        props.setprogress(50)
        const response = await fetch(`${host}/api/notes/fetchdetails`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                "auth-token": localStorage.getItem('token')
            }
        });
        const json = await response.json();
        setnotes(json)
        props.setprogress(100)
    }

    const addnotes = async (title, description, tag) => {
        props.setprogress(50)
        const response = await fetch(`${host}/api/notes/adddetails`, {
            method: 'POST',
            headers: {
                "auth-token": localStorage.getItem('token'),
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ title, description, tag })
        });
        const notes = await response.json();
        setnotes(note.concat(notes))
        props.setprogress(100)
    }

    const editnotes = async (id, title, description, tag) => {
        props.setprogress(50)
        const response = await fetch(`${host}/api/notes/updatedetails/${id}`, {
            method: 'PUT',
            headers: {
                "auth-token": localStorage.getItem('token'),
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ title, description, tag })
        });
        const json = await response.json();
        console.log(json);
        
        let newnote = JSON.parse(JSON.stringify(note));
        for (let index = 0; index < newnote.length; index++) {
            const element = newnote[index];
            if (element._id === id) {
                newnote[index].title = title
                newnote[index].description = description
                newnote[index].tag = tag
                break;
            }
        }
        setnotes(newnote);
        props.setprogress(100)
    }

    const deletenotes = async(id) => {
        props.setprogress(50)
        const response = await fetch(`${host}/api/notes/deletedetails/${id}`, {
            method: 'DELETE',
            headers: {
                "auth-token": localStorage.getItem('token'),
                "Content-Type": "application/json"
            }
        });
        const json = await response.json();
        console.log(json);
        const newnote = note.filter((note) => { return note._id !== id })
        setnotes(newnote)
        props.setprogress(100)
    }

    return <NoteContext.Provider value={{ note, addnotes, editnotes, deletenotes, getnotes }}>
        {props.children}
    </NoteContext.Provider>
}

export default NoteState